import axios from 'axios';

const BASE = '/comprobantes/comprobantes';

export default {
  show(id) {
    return axios.get(`${BASE}/${id}`);
  },

  pdf(id) {
    return axios.get(`/comprobantes/generate/pdf?q=${id}`, { responseType: 'blob' });
  },
};
